import { ApiService, GenericError} from './api-main'
import TokenService from './token-service'
import store from '../store'

class OtpError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const OtpService = {

    requestPing: async function() {
        return "OK";
    },

    requestotp: async function(accessLevel) {
        let returnReponse = {status:false }
        // let otpMobileNo   = (ApiService.getFormData("login-userId-entered") == ApiService.getFormData("p2hCustomerId")) ? ApiService.getFormData("shMobileNo") : ''
        try {
            ApiService.setHeader()
            var url      = 'main/potential/otp'
            var token    = `Bearer ${TokenService.getToken()}`
            if (accessLevel != undefined){
                if (accessLevel == 6){ // during registration
                    url      = 'main/potential/otp';
                }else if (accessLevel == 7){ // during login
                    url      = 'main/login/otp'
                    token    = `Bearer ` + ApiService.getFormData("tempToken")
                }else if (accessLevel == 4 || accessLevel == 2){ // during update mobile number or edit trx
                    url      = 'main/otp';
                }
            }

            let axiosHeader= {
                headers: {
                    'Content-Type'                : 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin" : '*',
                    "Authorization"               : token,
                    "Client-Id"                   : process.env.VUE_APP_CLIENT_ID,
                    "WANDRE-OTP-UUID"             : ApiService.getFormData("uuid")
                },
                params: {
                    
                },
            };

            if (accessLevel == 7){ // during login
                axiosHeader.headers["WANDRE-DeviceId"] = "af206a1b9579311235714bfd445fba6c"; 
            } else if(accessLevel == 4) { // during update mobile number
                axiosHeader.headers["WANDRE-ClientId"] = 7; 
                axiosHeader.headers["WANDRE-DeviceId"] = "af206a1b9579311235714bfd445fba6c";
                axiosHeader.headers["WANDRE-MobileCountryId"] = store.state.misc.newMobileCountryId; 
                axiosHeader.headers["WANDRE-Mobile"] = store.state.misc.newMobileNo; 
            }else if(accessLevel == 2){
                axiosHeader.headers["WANDRE-ClientId"] = 7; 
                axiosHeader.headers["WANDRE-DeviceId"] = "af206a1b9579311235714bfd445fba6c";
            }

            await ApiService.generateAuthClient();
            const response = await ApiService.customHeader(url,{},axiosHeader, "post")

            ApiService.saveFormData("uuid",response.data.result.uuid);
            ApiService.saveFormData("prefix",response.data.result.prefix);

            ApiService.saveFormData("otpIDD",response.data.result.otpIDD);
            ApiService.saveFormData("otpMobilePhone",response.data.result.otpMobilePhone);

            returnReponse.status = true
            returnReponse.data = ApiService.validateResponse(response, '4000')

            return returnReponse
        } catch (e) {
            console.log(e.response);
            returnReponse.status = false

            if(e.response.data.status == '90008'){
                returnReponse.message = "otp-invalid-text-8"
            }else{
                returnReponse.message = "otp-invalid-text"
            }

            if (e instanceof GenericError) {
                throw e
            }
            return returnReponse;
        }
    },

    /**
     * Validate OTP.
     *
     * @returns rquest response
     * @throws OtpError
    **/
    // validateOtp: async function(otp) {
    //     let returnReponse = {status:false }

    //     try {
    //         ApiService.setHeader()
    //         let axiosHeader= {
    //             headers: {
    //                 'Content-Type'                : 'application/json;charset=UTF-8',
    //                 "Access-Control-Allow-Origin" : '*',
    //                 "Authorization"               : `Bearer ${TokenService.getToken()}`,
    //                 "P2H-OTP-UUID"                : ApiService.getFormData("uuid"),
    //                 "P2H-CustomerId"              : ApiService.getFormData("p2hCustomerId"),
    //                 "P2H-OTP-Code"                : otp
    //             }
    //         };
    //         var url      = 'main/customer/partner/validateotp'

    //         const response = await ApiService.customHeader(url,{},axiosHeader)

    //         returnReponse.status = true
    //         if(response.data.status != "SH1000"){
    //             returnReponse.status = false;
    //             if(response.data.status == '90008'){
    //                 returnReponse.message = "otp-invalid-text-8"
    //             }else if(response.data.status == '90011'){
    //                 returnReponse.message = "otp-invalid-text-11"
    //             }else if(response.data.status == '90014'){
    //                 returnReponse.message = "otp-invalid-text-14"
    //             }else{
    //                 returnReponse.message = "otp-invalid-text-14"
    //             }
    //         }else{
    //             returnReponse.data = response.data.result;
    //             ApiService.saveFormData("otp", otp);
    //         }

    //         return returnReponse

    //     } catch (e) {
    //         const statusCode = e.response.data.status
    //         console.log(e.response)

    //         returnReponse.status = false
    //         if(statusCode == '90008'){
    //             returnReponse.message = "otp-invalid-text-8"
    //         }else if(statusCode == '90011'){
    //             returnReponse.message = "otp-invalid-text-11"
    //         }else if(statusCode == '90014'){
    //             returnReponse.message = "otp-invalid-text-14"
    //         }else{
    //             returnReponse.message = "otp-invalid-text"
    //         }

    //         if (e instanceof GenericError) {
    //             throw e
    //         }

    //         return returnReponse;
    //     }
    // }

}

export default OtpService

export { OtpService, OtpError }